import { Inject } from '@odinjs/odin';

import { Endpoint, ToastServiceProviderAccreditation } from '@philips-emr/hpms-provider-accreditation-commons';
import { ButtonAPI } from '@philips-emr/tws-components';
import { ButtonTheme, ModalButtonType } from '@philips-emr/tws-constants';
import Controller, { OnClick, OnMount } from '@philips-emr/tws-core/lib/client';
import { HttpService, ModalButton, ModalProps, ModalService, msg } from '@philips-emr/tws-core/lib/services';
import { isEmptyArrayOrObject } from '@philips-emr/tws-utils';

import BaseController from '../BaseController';

interface User {
  nrSequence: number,
  response: string,
}
@Controller({ fragment: 'provider-accreditation-validation' })
export default class ProviderAccreditationValidationController extends BaseController {

  @Inject('button-submit-accreditation')
  private buttonSubmitAccreditation: ButtonAPI;

  @OnMount('panel-provider-accreditation-validation')
  onMountPanel(): void {
    const { nrSeqUser, nrSeqAccreditation } = this.historyService.getCurrentRouteParams();
    void HttpService.get(Endpoint.GET.ACCREDITATION_PENDENCES, { nrSeqAccreditation, nrSeqUser }).then(resp => {
      const data = resp.body as [];
      if (isEmptyArrayOrObject(data)) {
        this.buttonSubmitAccreditation.setEnabled(true);
      }
    });
  }

  @OnClick('button-submit-accreditation')
  onClickButtonSubmit(): void {
    ModalService.openDialog(this.newModalDefaultContent());
  }

  private newModalDefaultContent(): ModalProps {
    const modalDefaultContent: ModalProps = {
      closeable: false,
      dialogDescription: 'pa.submit-accreditation-no-change',
      dockButtons: this.newDockButtons(),
      title: 'pa.question-submit-accreditation',
    };

    return modalDefaultContent;
  }

  private newDockButtons(): ModalButton[] {

    const onOk = (): void => {
      const { nrSeqAccreditation, nrSeqUser } = this.historyService.getCurrentRouteParams();
      void HttpService.put(Endpoint.PUT.PROVIDER_VALIDATION, { nrSeqAccreditation, nrSeqUser })
        .then(() => {
          ToastServiceProviderAccreditation.successBubble(msg('pa.change-made-successfully'));
        }).catch(resp => {
          const { response } = resp.body as User;
          ToastServiceProviderAccreditation.warning(response);
        });
    };

    const onCancel = (): void => {
      return;
    };

    const dockButtons: ModalButton[] = [
      {
        action: onCancel,
        theme: ButtonTheme.SECONDARY,
        title: 'pa.cancel',
        type: ModalButtonType.CANCEL,
      },
      {
        action: onOk,
        title: 'pa.yes-string',
        type: ModalButtonType.SUCCESS,
      },
    ];

    return dockButtons;
  }
}
